// extracted by mini-css-extract-plugin
export default {"Page":"HansDemo_Page__vBRP+","Frame":"HansDemo_Frame__498Nf"};